import type { PageContent } from "../content/index.js";

declare const __EXPHO_SITE_BASE_URL__: string;

export const WHATSAPP_NUMBER = "5531999409834";

export const INSTAGRAM_HANDLE = "kuori.app";

export const INSTAGRAM_URL = `https://www.instagram.com/${INSTAGRAM_HANDLE}/`;

export function whatsappTo(text: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export function whatsappHref(content: PageContent, text: string = content.meta.whatsapp): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export function siteBaseUrl(): string {
  const base = typeof __EXPHO_SITE_BASE_URL__ === "string" ? __EXPHO_SITE_BASE_URL__ : "";
  return base.replace(/\/$/, "");
}

export function absolute(path: string): string {
  return `${siteBaseUrl()}${path}`;
}
